<nav #header class="fixed-top headerStyle" style="background-color: white;filter: drop-shadow(1px 1px 1px #6666664d);"
    [ngClass]="{'navbar2': this.companyParamsService.getFadeMenu()}">
    <div class="container green">
        <div class="containerMenu navbar-collapse collapse">
            <div class="call-container">
                <div class="logo-desktop">
                    <a href="https://www.galapagosedentravel.com/home" target="_blank">
                        <img class="logo" src="../assets/images/logos-header/ged.svg" />
                    </a>
                </div>
                <div class="contactContainer">
                    <ul class="navbar-nav contact">
                        <li class="nav-item menuItem1" style="text-align: right;">
                            <a href="https://www.galapagosedentravel.com/home" target="_blank"><i
                                    class="fa fa-user-circle"></i>
                                <span>Iniciar sesión</span></a>
                        </li>
                        <li class="nav-item menuItem1" style="text-align: right;">
                            <a href="https://www.galapagosedentravel.com/home" target="_blank">
                                <i class="fa fa-shopping-bag"></i>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="logo-container">
                <div class="logo-mobile">
                    <a href="https://www.galapagosedentravel.com/home" target="_blank">
                        <img class="logo" src="../assets/images/logos-header/ged.svg" />
                    </a>
                </div>
                <div class="menuButton">
                    <a (click)="renderMenu()" href="javascript:void()"><i class="fa fa-bars"></i></a>
                </div>
            </div>
            <div class="contactContainerMobile">
                <ul class="navbar-nav contact">
                    <li class="nav-item menuItem1" style="text-align: right;">
                        <a href="https://www.galapagosedentravel.com/home" target="_blank"><i
                                class="fa fa-user-circle"></i>
                            <span>Iniciar sesión</span></a>
                    </li>
                    <li class="nav-item menuItem1" style="text-align: right;">
                        <a href="https://www.galapagosedentravel.com/home" target="_blank">
                            <i class="fa fa-shopping-bag"></i>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="containerHeader" [ngClass]="showMenu ? 'showMenu':''">
            <ul class="navbar-nav desktop-list" [ngClass]="showMenu ? 'menu-backcolor':''">
                <li class="nav-item menuItem"><a href="https://www.galapagosedentravel.com/" target="_blank">Inicio</a>
                </li>
                <li class="nav-item menuItem"><a href="https://www.galapagosedentravel.com/cruceros"
                        target="_blank">GALAPAGOS CRUISES</a></li>
                <li class="nav-item menuItem"><a href="https://www.galapagosedentravel.com/copia-de-galapagos-cruises"
                        target="_blank">INTERISLAND TRANSPORT SERVICE</a></li>
                <li class="nav-item menuItem"><a href="https://www.galapagosedentravel.com/projects-3"
                        target="_blank">FULL DAYS TOURS</a></li>
                <li class="nav-item menuItem"><a href="https://www.galapagosedentravel.com/copia-de-daphne"
                        target="_blank">SANTA CRUZ ISLANDS TOURS</a>
                </li>
                <li class="nav-item menuItem"><a href="https://www.galapagosedentravel.com/projects-2"
                        target="_blank">SAN CRISTOBAL ISLAND TOURS</a>
                </li>
                <li class="nav-item menuItem menuItemLast"><a href="https://www.galapagosedentravel.com/book-online"
                        target="_blank">More</a>
                </li>
                <li *ngIf="companyParamsService.getFiltersInterest()">
                    <div class="wishlist tooltip-container">
                        <app-heart-header></app-heart-header>
                    </div>
                </li>
            </ul>
        </div>

    </div>
</nav>